import dayjs from "dayjs";

import { useTimezone } from "@web-app/api";
import { TimeFormat } from "@web-app/types";
import { timeZoneMap } from "@web-app/utils/helpers";

import Tooltip from "../Tooltip";

export default function TrackingPageTz({
  date,
  userDate,
  timezone,
  popupPosition,
}: {
  date: Date;
  popupPosition: "left" | "right" | "top";
  timezone: Partial<keyof typeof timeZoneMap>;
  userDate: Date;
}) {
  const { userTimezone } = useTimezone();

  if (timezone === "system") {
    return <FormattedDate date={date} timezone={timezone} />;
  }

  return (
    <span>
      <Tooltip
        text={<FormattedDate date={userDate} timezone={userTimezone} />}
        position={popupPosition}
        tooltipClassName="w-[160px]"
      >
        <span>
          <FormattedDate date={date} timezone={timezone} />
        </span>
      </Tooltip>
    </span>
  );
}

const FormattedDate = ({
  date,
  timezone,
}: {
  date: Date;
  timezone?: Partial<keyof typeof timeZoneMap>;
}) => {
  const { getTimezone } = useTimezone();

  if (!dayjs(date).isValid()) {
    return <span></span>;
  }

  // Convert UTC time to specified timezone for display
  const effectiveTimezone = getTimezone(timezone);
  const formatted =
    effectiveTimezone === "system"
      ? dayjs(date).format(TimeFormat.hour_minute_am_pm_tz)
      : dayjs
          .utc(date)
          .tz(effectiveTimezone)
          .format(TimeFormat.hour_minute_am_pm_tz);

  return <span>{formatted}</span>;
};
